<template>
  <div class="barcode-dialog-area" v-if="manufacturingPlan">
    <el-dialog
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      width="50%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="manufacturing-dialog">
        <div class="manufacturing-dialog-content">
          <div class="dialog-field">
            <span class="field-label">{{ $t('manufactured_order_number') }}</span>
            <span class="field-separator">:</span>
            <span class="field-value">{{ manufacturingPlan.orderNumber }}</span>
          </div>
          <div class="dialog-field">
            <span class="field-label">{{ $t('item_code') }}</span>
            <span class="field-separator">:</span>
            <span class="field-value">{{ manufacturingPlan.itemCode }}</span>
          </div>
          <div class="dialog-field">
            <span class="field-label">{{ $t('item_name') }}</span>
            <span class="field-separator">:</span>
            <span class="field-value">{{ manufacturingPlan.itemName }}</span>
          </div>
          <div class="dialog-field">
            <span class="field-label">{{ $t('manufactured_completion_date') }}</span>
            <span class="field-separator">:</span>
            <span class="field-value">{{ formattedCompletionDate }}</span>
          </div>
          <div class="dialog-field">
            <span class="field-label">{{ $t('manufactured_planned_quantity_stock_unit') }}</span>
            <span class="field-separator">:</span>
            <span class="field-value"
              >{{ manufacturingPlan.plannedQuantityStockUnit }} {{ manufacturingPlan.stockUnit }}</span
            >
          </div>
          <div class="dialog-field">
            <div class="lot-label">{{ $t('LOT_number') }}</div>
            <input :value="lotNumber" @input="handleLotNumberInput" type="text" class="lot-input" />
          </div>
          <div class="action-buttons">
            <button class="action-btn start-btn" @click="handleBegin">{{ $t('begin') }}</button>
            <button class="action-btn return-btn" @click="handleClose">{{ $t('return') }}</button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { IManufacturingPlan } from '@/utils/types/barcodeTypes'
import dayjs from 'dayjs'
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'ManufacturingPlanDialog',
  emits: ['update:modelValue', 'update:lotNumber', 'begin', 'close'],
})
export default class ManufacturingPlanDialog extends Vue {
  @Prop({ type: Boolean, default: false }) modelValue!: boolean
  @Prop({ required: true }) manufacturingPlan!: IManufacturingPlan
  @Prop({ type: String, default: '' }) lotNumber!: string

  get formattedCompletionDate(): string {
    if (!this.manufacturingPlan?.manufactureCompletionDate) return ''
    const format = this.$t('date_format')
    return dayjs(new Date(this.manufacturingPlan.manufactureCompletionDate)).format(format)
  }

  handleLotNumberInput(event: Event) {
    const target = event.target as HTMLInputElement
    this.$emit('update:lotNumber', target.value)
  }

  handleBegin() {
    this.$emit('begin')
  }

  handleClose() {
    this.$emit('close')
  }
}
</script>

<style lang="scss" scoped>
.barcode-dialog-area {
  :deep(.el-dialog) {
    padding: 0;
  }

  :deep(.el-dialog__header) {
    display: none;
  }

  :deep(.el-dialog__body) {
    padding: 0;
  }

  .manufacturing-dialog {
    background: linear-gradient(135deg, #ffffff 0%, #8e8e8e 100%);
    border: 3px solid #000;
    padding: 20px 30px;
    min-width: 400px;
    font-family: sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .manufacturing-dialog-content {
    width: 85%;
  }

  .dialog-field {
    display: flex;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 1.8;
    justify-content: center;
    align-items: center;
  }

  .field-label {
    color: #000;
    font-weight: normal;
    font-size: 25px;
  }

  .field-separator {
    margin: 0 4px;
    font-size: 25px;
  }

  .field-value {
    color: #000;
    font-size: 25px;
    font-weight: normal;
  }

  .lot-label {
    color: #000;
  }

  .lot-input {
    border: 1px solid #000;
    outline: none;
    padding: 0px 10px;
    font-size: 25px;
    background: white;
    font-family: sans-serif;
    width: 35%;
  }

  .action-buttons {
    display: flex;
    gap: 30px;
    margin-top: 25px;
    justify-content: space-around;
  }

  .action-btn {
    min-width: 100px;
    padding: 10px 30px;
    font-size: 40px;
    font-weight: bold;
    border: 1px solid #000;
    background: white;
    cursor: pointer;
    font-family: sans-serif;
  }
}
</style>
